import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=2e0daeae&scoped=true"
import script from "./ProjectTable.vue?vue&type=script&lang=ts"
export * from "./ProjectTable.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTable.vue?vue&type=style&index=0&id=2e0daeae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0daeae",
  null
  
)

export default component.exports